<div class="pod-section" [formGroup]="form" *ngIf="isVisible">

  <h2 class="pod-section__title">{{ sectionLabel }}</h2>

  <div class="pod-grid">

    <div class="pod-field pod-field--full">
      <div class="pod-file-error" *ngIf="bannerMessage">
        <span class="one-icon-warning-outline"></span>
        {{ bannerMessage }}
      </div>

      <ng-container *ngIf="isLinkMode; else fileUploadOrPreview">
        <div class="pod-link-card">
          <div class="pod-link-card__icon">
            <svg width="106" height="106" viewBox="0 0 106 106" fill="none" xmlns="http://www.w3.org/2000/svg" style="padding: 2px;">
              <circle cx="53" cy="53" r="52.5" stroke="#4589FF" />
              <path d="M76.5 33.5L66 24H36C34.1667 24 30.5 25.1 30.5 29.5C30.5 33.9 30.5 63.6667 30.5 78C30.6667 79.8333 32 83.5 36 83.5C40 83.5 61.3333 83.5 71.5 83.5C73.1667 83.3333 76.5 82 76.5 78C76.5 74 76.5 46.6667 76.5 33.5ZM66 24C65.5 25.6667 65 29.5 67 31.5C69 33.5 74.1667 33.6667 76.5 33.5" stroke="#4589FF" />
              <g clip-path="url(#clip0_1119_54341)">
                <path d="M61 44H49C47.9 44 47 44.9 47 46V58C47 59.1 47.9 60 49 60H61C62.1 60 63 59.1 63 58V46C63 44.9 62.1 44 61 44ZM44 48C43.45 48 43 48.45 43 49V62C43 63.1 43.9 64 45 64H58C58.55 64 59 63.55 59 63C59 62.45 58.55 62 58 62H46C45.45 62 45 61.55 45 61V49C45 48.45 44.55 48 44 48Z" fill="#4589FF" />
              </g>
              <defs>
                <clipPath id="clip0_1119_54341">
                  <rect width="24" height="24" fill="white" transform="translate(41 42)" />
                </clipPath>
              </defs>
            </svg>
          </div>
          <button type="button" class="pod-link-card__btn" (click)="goToLink()">
            Go to files
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
              <path d="M6 4h6v6M12 4L5 11M4 8v4h4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
      </ng-container>

      <ng-template #fileUploadOrPreview>
        <ng-container *ngIf="!uploadedFileName && !viewMode; else filePreview">
          <div class="pod-file-zone"
            [class.file-required]="hasFileError"
            (dragover)="$event.preventDefault()"
            (drop)="onFileDrop($event)">
            <input
              type="file"
              accept="application/pdf"
              class="pod-file-zone__input"
              #fileInput
              (change)="onFileChange($event)"
            />
            <svg class="pod-file-zone__illustration" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <circle cx="60" cy="60" r="55" stroke="#D0D5DD" stroke-width="1.5"/>
              <rect x="38" y="32" width="36" height="44" rx="3" stroke="#BCC0C8" stroke-width="1.5"/>
              <path d="M62 32v12h12" stroke="#BCC0C8" stroke-width="1.5" stroke-linejoin="round"/>
              <path d="M60 72V52M53 59l7-7 7 7" stroke="#BCC0C8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span class="pod-file-zone__text">Drag and drop files here or</span>
            <button type="button" class="pod-file-zone__browse" (click)="fileInput.click()">
              Browse file
            </button>
          </div>
        </ng-container>
        <ng-template #filePreview>
          <div class="pod-file-card" [class.pod-file-card--uploading]="uploading" [class.pod-file-card--error]="fileErrorType === ERROR_TYPE.UPLOAD_FAILED">
            <div class="pod-file-card__icon-wrap">
              <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M21 3H9a3 3 0 0 0-3 3v24a3 3 0 0 0 3 3h18a3 3 0 0 0 3-3V12L21 3z" stroke="#4589ff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M21 3v9h9" stroke="#4589ff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                <text x="9" y="27" font-size="8" fill="#4589ff" font-family="sans-serif" font-weight="700" letter-spacing="0.5">PDF</text>
              </svg>
            </div>
            <span class="pod-file-card__name" [title]="uploadedFileName">{{ uploadedFileName }}</span>
            <span *ngIf="uploading" class="pod-file-card__status">Uploading…</span>
            <span *ngIf="fileErrorType === ERROR_TYPE.UPLOAD_FAILED" class="pod-file-card__status pod-file-card__status--error">Upload failed</span>
            <div class="pod-file-card__actions" *ngIf="!uploading && fileErrorType !== ERROR_TYPE.UPLOAD_FAILED">
              <button type="button" class="pod-file-card__btn pod-file-card__btn--remove" (click)="removeFile()" *ngIf="!viewMode">
                Remove
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
                  <path d="M10.5 3.5l-7 7M3.5 3.5l7 7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                </svg>
              </button>
              <button type="button" class="pod-file-card__btn pod-file-card__btn--download" (click)="downloadFile()" *ngIf="viewMode" [disabled]="isDownloading">
                Download
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
                  <path d="M7 1v8M3.5 6.5L7 10l3.5-3.5M1.5 12.5h11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
              <button type="button" class="pod-file-card__btn pod-file-card__btn--preview" (click)="openPreview()" [disabled]="isPreviewing">
                Preview
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
                  <ellipse cx="7" cy="7" rx="6" ry="4" stroke="currentColor" stroke-width="1.4"/>
                  <circle cx="7" cy="7" r="1.8" fill="currentColor"/>
                </svg>
              </button>
            </div>
          </div>
        </ng-template>
      </ng-template>
    </div>

  </div>
</div>
